import { render, staticRenderFns } from "./BinNo.vue?vue&type=template&id=21dc257a&"
import script from "./BinNo.vue?vue&type=script&lang=js&"
export * from "./BinNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports